// extracted by mini-css-extract-plugin
module.exports = {"lineClamp":"LineClampItem_lineClamp__2sHxu","lineExpand":"LineClampItem_lineExpand__2r1Bp","expandButton":"LineClampItem_expandButton__1HckL"};